import styled from 'styled-components'

export const Link = styled.a`
  	font-size: 16px;
  text-transform: uppercase;
  font-weight: 600;
  
	&:not(:last-child) {
      margin-right: 30px;
	}
`